module.exports = __webpack_public_path__ + "static/img/20070026C2.eca9d379.png";